// extracted by mini-css-extract-plugin
module.exports = {"assignInfo":"_3CYQ7S4jPTEDWwvfZ69N3h","editBtn":"_24At1inwaRgufK40yzVik_","icon":"_1WhGcPktG-Zov9nGwyFxLn"};